import * as React from 'react';
import { IconChevronRight12, Image, UIHeading4 } from '@cian/ui-kit';
import { FC } from 'react';

import styles from './styles.css';

interface IListItem {
  handleClick: () => void;
  imageUrl: string;
  title: string;
}
export const ListItem: FC<IListItem> = ({ title, handleClick, imageUrl }) => {
  return (
    <div className={styles['list-item']} onClick={handleClick}>
      <div className={styles['item-info']}>
        <Image width={40} height={40} src={imageUrl} />
        <UIHeading4>{title}</UIHeading4>
      </div>
      <IconChevronRight12 color="primary_100" />
    </div>
  );
};
